import {useMemo} from "react"
import {useSearchParams} from 'react-router-dom';
import CallMeFloatingComponent from "./CallMeFloatingComponent.tsx";

const UtmSources: string[] = [
    '1167664433', // tjekbredbaand.dk
]

export default function CallMeFloatingDenyVisibilityComponent() {
    const [searchParams] = useSearchParams();

    const visibilityDenied = useMemo(() => {
        const utm_source = searchParams.get('utm_source')
        return utm_source !== null && UtmSources.includes(utm_source)
    }, [searchParams])

    return <CallMeFloatingComponent denyVisibility={visibilityDenied}/>
}
